module.exports = __webpack_public_path__ + "static/media/land.4f7f252c.svg";